// src/components/PraemieTabs.js
import React, { useState, useEffect } from 'react';

const PraemieTabs = ({ praemieData, praemieDataLastYear, styles }) => {
  //console.log("PraemieTabs gerendert mit:", { praemieData, praemieDataLastYear });
  
  // Mögliche Tabs: 'lastyear-firsthalf', 'lastyear-secondhalf', 'currentyear-firsthalf', 'currentyear-secondhalf'
  const [activeTab, setActiveTab] = useState('currentyear-firsthalf');
  const [dataToDisplay, setDataToDisplay] = useState([]);

  // Extrahieren der relevanten Daten aus der Struktur
  useEffect(() => {
   // console.log("Verarbeite Prämiendaten für Tab:", activeTab);
    
    if (activeTab === 'currentyear-firsthalf') {
      if (praemieData?.currentyear?.firsthalf) {
        setDataToDisplay(praemieData.currentyear.firsthalf);
      } else if (Array.isArray(praemieData)) {
        setDataToDisplay(praemieData);
      } else {
        setDataToDisplay([]);
      }
    } 
    else if (activeTab === 'currentyear-secondhalf') {
      if (praemieData?.currentyear?.secondhalf) {
        setDataToDisplay(praemieData.currentyear.secondhalf);
      } else if (Array.isArray(praemieData)) {
        setDataToDisplay(praemieData);
      } else {
        setDataToDisplay([]);
      }
    } 
    else if (activeTab === 'lastyear-firsthalf') {
      if (praemieData?.lastyear?.firsthalf) {
        setDataToDisplay(praemieData.lastyear.firsthalf);
      } else if (Array.isArray(praemieDataLastYear)) {
        setDataToDisplay(praemieDataLastYear);
      } else {
        setDataToDisplay([]);
      }
    } 
    else if (activeTab === 'lastyear-secondhalf') {
      if (praemieData?.lastyear?.secondhalf) {
        setDataToDisplay(praemieData.lastyear.secondhalf);
      } else if (Array.isArray(praemieDataLastYear)) {
        setDataToDisplay(praemieDataLastYear);
      } else {
        setDataToDisplay([]);
      }
    }
  }, [activeTab, praemieData, praemieDataLastYear]);

  // Hilfsfunktion zur Darstellung der Tabelle
  const renderTable = (data) => {
    if (!Array.isArray(data) || data.length === 0) {
      return <div className="no-data-message">Keine Prämiendaten für diesen Zeitraum verfügbar.</div>;
    }

    return (
      <table className={styles?.tablex || 'data-table'}>
        <thead>
          <tr>
            <th>Prämie</th>
            <th>Abweichung der ∅-Stunden bis Ziel</th>
            <th>∅-Stunden bis Ziel</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td className={styles?.tdx || ''} style={{ textAlign: 'left' }}>
                {item.prämie}
              </td>
              <td
                className={styles?.tdx || ''}
                style={{
                  textAlign: 'center',
                  color: item.abweichung < 0 ? 'red' : 'green',
                  fontWeight: 'bold',
                }}
              >
                {item.abweichung < 0
                  ? `${item.abweichung}`
                  : `+${item.abweichung}`}
              </td>
              <td className={styles?.tdx || ''} style={{ textAlign: 'center' }}>
                {item.stundenBisZiel}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <div className={styles?.chartx || 'chart-card'}>
      <div className={styles?.chartHeaderx || 'chart-header'}>
        <h3>Prämienübersicht</h3>
      </div>

      {/* Tab-Navigation */}
      <div className="praemie-tabs">
        <button
          onClick={() => setActiveTab('currentyear-firsthalf')}
          className={`tab-button ${activeTab === 'currentyear-firsthalf' ? 'active' : ''}`}
        >
          Aktuelles Jahr - 1. Halbjahr
        </button>
        <button
          onClick={() => setActiveTab('currentyear-secondhalf')}
          className={`tab-button ${activeTab === 'currentyear-secondhalf' ? 'active' : ''}`}
        >
          Aktuelles Jahr - 2. Halbjahr
        </button>
        <button
          onClick={() => setActiveTab('lastyear-firsthalf')}
          className={`tab-button ${activeTab === 'lastyear-firsthalf' ? 'active' : ''}`}
        >
          Vorjahr - 1. Halbjahr
        </button>
        <button
          onClick={() => setActiveTab('lastyear-secondhalf')}
          className={`tab-button ${activeTab === 'lastyear-secondhalf' ? 'active' : ''}`}
        >
          Vorjahr - 2. Halbjahr
        </button>
      </div>

      {/* Anzeige der Tabelle */}
      {renderTable(dataToDisplay)}

      <style jsx>{`
        .praemie-tabs {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          margin-bottom: 1.5rem;
        }
        
        .tab-button {
          padding: 0.5rem 1rem;
          background-color: #f3f4f6;
          border: 1px solid #d1d5db;
          border-radius: 4px;
          font-size: 0.9rem;
          cursor: pointer;
          transition: all 0.2s;
        }
        
        .tab-button:hover {
          background-color: #e5e7eb;
        }
        
        .tab-button.active {
          background-color: #3b82f6;
          color: white;
          border-color: #2563eb;
        }
        
        .no-data-message {
          padding: 2rem;
          text-align: center;
          background-color: #f9fafb;
          border-radius: 6px;
          color: #6b7280;
        }
      `}</style>
    </div>
  );
};

export default PraemieTabs;